import * as React from 'react';
import spinner from './assets/spinner.gif';
import ReactModal from 'react-modal';
import CSSModules from "react-css-modules";
import styles from "./Modal.scss";

interface ISplashProps {
  isOpen : boolean;
}


@CSSModules(styles, { allowMultiple: true })
export class Splash extends React.Component <ISplashProps> {

  render() {
    const  {isOpen} = this.props;
    return  (<ReactModal  style={{overlay: {
                                        },
                                 content: {
                                          textAlign             : 'center',
                                          top                   : '50%',
                                          left                  : '50%',
                                          right                 : 'auto',
                                          bottom                : 'auto',
                                          transform             : 'translate(-50%, -50%)',
                                          padding               : '50px 20px',
                                          minWidth              : '210px',
                                          lineHeight            : '25px',
                                        }
                                      }}
                         isOpen={isOpen}>
      <div styleName="spinnerContainer">
        <img src={spinner} alt="spinner" width="50" />
      </div>
      <div data-at="make-a-payment-modal">This may take up to 60 seconds. Please don’t refresh your page or click the back button.</div>
    </ReactModal>);
  }
}






// WEBPACK FOOTER //
// ./src/components/modal/Modal.js